import store from '../store';
export default (axios) => {
    axios.interceptors.response.use(function (response) {
        // 成功時の処理
        return response;
    }, function (error) {
        // 失敗時の処理
        console.error(error.response.data);
        if (401 === error.response.status) {
            store.dispatch("auth", { loginUser: [], islogin: false });
            alert('セッションがタイムアウトしました。\n再度ログインしてください。');
            window.location = '/';
            // #966での暫定対策によりコメントアウト。今後本対策実施後コメントアウト解除予定。
            // } else if (500 === error.response.status) {
            //     store.dispatch("auth", { loginUser: [], islogin: false });
            //     alert(`${error.response.statusText}\n${error.response.data}`);
            //     return Promise.reject(error);
        } else {
            return Promise.reject(error);
        }
    });
}